import type { MessageInstance } from 'antd/es/message/interface';
import type { ModalStaticFunctions } from 'antd/es/modal/confirm';
import type { NotificationInstance } from 'antd/es/notification/interface';

export const antdHolder: {
  message: MessageInstance | null;
  notification: NotificationInstance | null;
  modal: Omit<ModalStaticFunctions, 'warn'> | null;
} = {
  message: null,
  notification: null,
  modal: null,
};
